export enum MasterOperatorFields {
  Layer = 'Layer',
  MapStep = 'MapStep',
  OperatorConnectSettings = 'OperatorConnectSettings',
  ConnectSettings = 'ConnectSettings',
  AttributesMetadata = 'AttributesMetadata',
  AttributeResults = 'AttributeResults',
  LayersVisibility = 'LayersVisibility',
  ScenarioVisibility = 'ScenarioVisibility',
  ThematicChanged = 'ThematicChanged'
}
